export enum EmailMode {
  New = 'new',
  Reply = 'reply',
  ReplyToSubject = 'replyToSubject',
}

export type EmailModeType =
  EmailMode.New | EmailMode.Reply | EmailMode.ReplyToSubject;
